
angular.module('admin.directives').directive('compare', function () {
    return {
        require: 'ngModel',
        link: function (scope, element, attrs, ctrl) {
            var modelToMatch = attrs.compare;
            scope.$watch(attrs.compare, function () {
                ctrl.$validate();
            });

            ctrl.$validators.compare = function (modelValue, viewValue) {
                
                var comparedValue = scope.$eval(modelToMatch);
                return viewValue === comparedValue;
            };
        }
    };
})
.directive('uiCeCnpjMask', ['CnpjUtils', function (CnpjUtils) {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function (scope, element, attrs, ngModel) {
            ngModel.$formatters.push(function (modelValue) {
                if (!modelValue) return modelValue;
                return CnpjUtils.format(modelValue);
            });

            ngModel.$parsers.push(function (viewValue) {
                if (!viewValue) return viewValue;

                var clean = CnpjUtils.clean(viewValue);
                var formatted = CnpjUtils.format(clean);

                if (viewValue !== formatted) {
                    ngModel.$setViewValue(formatted);
                    ngModel.$render();
                }

                return clean;
            });

            ngModel.$validators.cnpj = function (modelValue) {
                return CnpjUtils.isValid(modelValue);
            };
        }
    };
}]);
